import { z } from 'zod'

export const ParticipantFormSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  email: z.union([
    z.string().email(),
    z.literal(''),
  ]).default('').optional(),
  phone: z.string().regex(/^(\+?[0-9 ]+)?$/, {
    message: 'phone.errors.invalid',
  }).nullable().optional(),
  address: z
    .object({
      address: z.string().optional(),
      addressLine2: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      zip: z.string().optional(),
      country: z.string().optional().nullable(),
    })
    .optional(),
  businessId: z
    .string()
    .regex(/[0-9]*/gi)
    .optional()
    .nullable(),
  taxId: z.string().optional().nullable(),
  accountNumber: z.string().optional().nullable(),
  iban: z.string().optional().nullable(),
  defaultBankAccountId: z.string().optional().nullable(),
})
